module.exports = __webpack_public_path__ + "img/icon_location_white.f782945.svg";